module.exports = __webpack_public_path__ + "img/bottom_right.f269175e.png";